import { render, staticRenderFns } from "./ReportWindow.vue?vue&type=template&id=18c1d70e&"
import script from "./ReportWindow.vue?vue&type=script&lang=js&"
export * from "./ReportWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports